'use client';

import type React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { CreditCardIcon, InfoIcon } from 'lucide-react';

interface MercadoPagoAuthModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onAuthorizeMercadoPago: () => void;
}

export const MercadoPagoAuthModal: React.FC<MercadoPagoAuthModalProps> = ({
  isOpen,
  onOpenChange,
  onAuthorizeMercadoPago,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CreditCardIcon className="h-5 w-5" />
            Sincronización con MercadoPago
          </DialogTitle>
          <DialogDescription>
            Para crear torneos necesitas sincronizar tu cuenta con MercadoPago.
          </DialogDescription>
        </DialogHeader>

        <Alert>
          <InfoIcon className="h-4 w-4" />
          <AlertDescription>
            MercadoPago es obligatorio para crear y gestionar torneos.
          </AlertDescription>
        </Alert>

        <DialogFooter className="flex-col gap-2 sm:flex-row">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="w-full sm:w-auto"
          >
            Cancelar
          </Button>
          <Button onClick={onAuthorizeMercadoPago} className="w-full sm:w-auto">
            Sincronizar con MercadoPago
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
